import { render, staticRenderFns } from "./PorComentarioSituacoes.vue?vue&type=template&id=6e20d678&scoped=true&lang=pug&"
import script from "./PorComentarioSituacoes.vue?vue&type=script&lang=js&"
export * from "./PorComentarioSituacoes.vue?vue&type=script&lang=js&"
import style0 from "./PorComentarioSituacoes.vue?vue&type=style&index=0&id=6e20d678&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e20d678",
  null
  
)

export default component.exports